import React, { useState, useEffect, useRef } from "react";


import { FaFireAlt } from "react-icons/fa";

import { FaFeatherAlt } from "react-icons/fa";
import { ImMagicWand } from "react-icons/im";



import './App.css';


                       
                       
function App() {
  return (
    <div className='todo-app'>
      <TodoList />
    </div>
  );
}

function TodoList() {
  const [todos, setTodos] = useState([]);

  const addTodo = todo => {
    if (!todo.text || /^\s*$/.test(todo.text)) {
      return;
    }

    const newTodos = [todo, ...todos];

    setTodos(newTodos);
    console.log(...todos);
  };

  const updateTodo = (todoId, newValue) => {
    if (!newValue.text || /^\s*$/.test(newValue.text)) {
      return;
    }

    setTodos(prev => prev.map(item => (item.id === todoId ? newValue : item)));
  };

  const removeTodo = id => {
    const removedArr = [...todos].filter(todo => todo.id !== id);

    setTodos(removedArr);
  };

  const completeTodo = id => {
    let updatedTodos = todos.map(todo => {
      if (todo.id === id) {
        todo.isComplete = !todo.isComplete;
      }
      return todo;
    });
    setTodos(updatedTodos);
  };

  return (
    <>
      <h1>What Is Thy Bidding?</h1>
      <TodoForm onSubmit={addTodo} />
      <Todo
        todos={todos}
        completeTodo={completeTodo}
        removeTodo={removeTodo}
        updateTodo={updateTodo}
      />
    </>
  );
}




function TodoForm(props) {
  const [input, setInput] = useState(props.edit ? props.edit.value : '');

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  });

  const handleChange = e => {
    setInput(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();

    props.onSubmit({
      id: Math.floor(Math.random() * 10000),
      text: input
    });
    setInput('');
  };

  return (
    <form onSubmit={handleSubmit} className='todo-form'>
      {props.edit ? (
        <>
          <input
            placeholder= "Solemnly Swear I'm Up to No Good"            
            value={input}
            onChange={handleChange}
            name='text'
            ref={inputRef}
            className='todo-input edit'
          />
          <button onClick={handleSubmit} className='todo-button edit'>
            Mischief Managed
          </button>
        </>
      ) : (
        <>
          <input
            placeholder='Cast a spell'
            value={input}
            onChange={handleChange}
            name='text'
            className='todo-input'
            ref={inputRef}
          />
          <button onClick={handleSubmit} className='todo-button'>
            Magic <ImMagicWand />

          </button>
          
        </>
      )}
      
                
    </form>
  );
}



const Todo = ({ todos, completeTodo, removeTodo, updateTodo }) => {
  const [edit, setEdit] = useState({
    id: null,
    value: ''
  });

  const submitUpdate = value => {
    updateTodo(edit.id, value);
    setEdit({
      id: null,
      value: ''
    });
  };

  if (edit.id) {
    return <TodoForm edit={edit} onSubmit={submitUpdate} />;
  }

  return todos.map((todo, index) => (
    <div
      className={todo.isComplete ? 'todo-row complete' : 'todo-row'}
      key={index}
    >
      <p key={todo.id} onClick={() => completeTodo(todo.id)}>
        {todo.text}
      </p>
      <div className='icons'>
        
        <div class="tooltip">

           
        <FaFeatherAlt
          onClick={() => setEdit({ id: todo.id, value: todo.text })}
          className='edit-icon'
        />            
          
            <span className="tooltiptext">Edit with quill</span>
</div>


        
        <div class="tooltip">

        
        <FaFireAlt
          onClick={() => removeTodo(todo.id)}
          className='delete-icon'
        /> 
        
  <span id="delete-with-fire" className="tooltiptext">Delete with fire</span>
</div>
     
      </div>
    </div>
  ));
};


export default App;
